import type { ModelFilterType } from 'dashboard409a/components/ModelsTable/ModelsTable.types';

export enum ModelStatus {
  DRAFT = 'Draft',
  REVIEW = 'Review',
  IN_PROCESS_SCALAR_USA = 'In-process ScalarUSA',
  FINAL = 'Final',
  REVIEW_FINAL = 'Review Final',
  COMPLETE = 'COMPLETE'
}

/** @deprecated Prefer `ModelFilterType` from ModelsTable.types — kept for existing imports. */
export type ModelSearchOption = ModelFilterType;

export enum ValuationStatus {
  READY_FOR_ONBOARDING = 'Ready for onboarding',
  ONBOARDING_SENT = 'Onboarding sent',
  ONBOARDING_FINISHED = 'Onboarding finished',
  CLIENT_DOCS_RECEIVED = 'Client Docs received',
  CLIENT_DOCS_RECEIVED_SKIP_SUPPORT = 'Client Docs received (skip-support)',
  CLIENT_DOCS_RECEIVED_ASSIGN_INTERN = 'Client Docs received (ASSIGN INTERN)',
  MODEL_DRAFTED = 'Model drafted',
  DRAFT_PREPARED = 'Draft prepared',
  DRAFT_REVIEWED_AND_SENT = 'Draft reviewed and sent',
  CLIENT_APPROVAL_RECEIVED = 'Client Approval received',
  REPORT_IN_PROCESS = 'Report in process',
  FINAL_REPORT_UPLOADED = 'Final report uploaded',
  FINAL_SENT = 'Final Sent',
  WAITING = 'WAITING',
  AWAITING_FINAL_PAYMENT = 'AWAITING FINAL PAYMENT',
  CANCELLED = 'CANCELLED'
}

export const EngagementCategory = {
  EQUITY_COMPENSATION:'Equity Compensation',
  STOCK_COMPENSATION_EXPENSE:'Stock Compensation Expense',
  VALUATION_CONSULTING:'Valuation Consulting',
  DERIVATIVE_VALUATION:'Derivative Valuation',
  GIFT_AND_ESTATE_PLANNING:'Gift and Estate Planning',
  PPA_IMPAIRMENT:'PPA/Impairment',
  LITIGATION_CONSULTING:'Litigation Consulting',
  PORTFOLIO_VALUATION:'Portfolio Valuation',
  OPINIONS: 'Opinions',
  COMMERCIALIZATION_MODEL:'Commercialization Model',
  OTHER_TAX_VALUATION:'Other Tax Valuation',
  SBA:'SBA',
  DEBT_VALUATION:'Debt Valuation',
  ESOP:'ESOP',
  SOFTWARE: 'Software',
  TRANSFER_PRICING: 'Transfer Pricing',
} as const;

export const ALL_VALUATION_STAGES: ValuationStatus[] = [
  ValuationStatus.READY_FOR_ONBOARDING,
  ValuationStatus.ONBOARDING_SENT,
  ValuationStatus.ONBOARDING_FINISHED,
  ValuationStatus.CLIENT_DOCS_RECEIVED,
  ValuationStatus.CLIENT_DOCS_RECEIVED_SKIP_SUPPORT,
  ValuationStatus.CLIENT_DOCS_RECEIVED_ASSIGN_INTERN,
  ValuationStatus.MODEL_DRAFTED,
  ValuationStatus.DRAFT_PREPARED,
  ValuationStatus.DRAFT_REVIEWED_AND_SENT,
  ValuationStatus.CLIENT_APPROVAL_RECEIVED,
  ValuationStatus.REPORT_IN_PROCESS,
  ValuationStatus.FINAL_REPORT_UPLOADED,
  ValuationStatus.FINAL_SENT,
  ValuationStatus.WAITING,
  ValuationStatus.AWAITING_FINAL_PAYMENT,
  ValuationStatus.CANCELLED,
];

export const VALID_CURRENT_VALUATION_STAGES: ValuationStatus[] = ALL_VALUATION_STAGES.filter(
  stage => stage !== ValuationStatus.FINAL_SENT && stage !== ValuationStatus.CANCELLED
);


export const VALID_PAST_VALUATION_STAGES: ValuationStatus[] = ALL_VALUATION_STAGES.filter(
  stage => stage === ValuationStatus.FINAL_SENT || stage === ValuationStatus.CANCELLED
);
